import React, { memo, Component } from "react";
import { Droppable, Draggable } from "react-beautiful-dnd";
import classNames from "classnames";

import "./style.scss";

import { ItemSize } from "../../../services/ItemSize";

import {Context} from "store/Context";

class StrapDrop extends Component {
  handleClasses = (snapshot, dice, index, isDraggingOver) => {
    const classes = classNames("DiceWrapper", {
      isDragging: snapshot.isDragging,
      notDragging: !snapshot.isDragging,
      small: (dice.size && 1.4 >= parseFloat(dice.size.split(/[xX]+/)[1])) || dice.is_anagram,
      marginDice: this.context.product.dices.length === 1 && index === 0,
      isTassel: dice.category_type === "tassel",
      firstDice: index === 0,
      lastDice: index === this.context.product.dices.length - 1,
      DiceRemoved: snapshot.isDropAnimating && snapshot.isDragging && !snapshot.draggingOver
    });

    if (!dice.is_anagram) {
      if (snapshot.isDragging) {
        const el = document.querySelectorAll("#strapDrop .DiceWrapper")[index];
        const positionRight = ((el.style.transform.split(",") || []).shift() || "").includes("-");
        const targetDice = el.querySelector(".Dice");
        const diceTrash = el.querySelector(".Dice-Trash");
        const { width, height } = targetDice.getBoundingClientRect();
        const { width: trashWidth, height: trashHeigt } = diceTrash.getBoundingClientRect();
        if (diceTrash && targetDice) {
          Object.assign(diceTrash.style, {
            marginLeft: this.context.isMobile && positionRight ? 0 : `${positionRight ? "-" : ""}${width + trashWidth + 25}px`,
            marginTop: this.context.isMobile && positionRight ? `-${height + trashHeigt + 25}px` : `-40px`
          })
        }

        if (el) {
          if (!isDraggingOver) {
            if (!el.classList.contains("DiceShowTrash")) {
              if (targetDice && diceTrash) {
                el.classList.add("DiceShowTrash");
              }
            }
          } else {
            el.classList.remove("DiceShowTrash")
          }
        }
      } else {
        const el = document.querySelectorAll("#strapDrop .DiceShowTrash")[index];
        if (el) {
          el.classList.remove("DiceShowTrash")
        }
      }
    }
    return classes;
  };

  handlerStyle = (dice) => {
    const { mainCategory } = dice;
    const addMarginTop = ["Shapes", "LeatherLetters", "LeatherItems"].includes(mainCategory);
    return {
      ...(!addMarginTop ? {} : { marginTop: 5 }),
      ...ItemSize.getItemSize(dice, this.context.isMobile, true)
    }
  }

  showWasteBasket = snapshot => {
    const slider = document.querySelector(".DicesSlider");
    const wasteBasket = document.querySelector(".WasteBasket");
    if (snapshot.isDragging && slider && wasteBasket) {
      slider.classList.add("disabled");
      wasteBasket.classList.add("active");
    } else if (!snapshot.isDragging && slider) {
      slider.classList.remove("disabled");
      wasteBasket.classList.remove("active");
    }
  };

  render() {
    const { isSlider } = this.props;
    const { product, getDicesHeight } = this.context;
    const { strap, dices } = product;
    
    return (
      <div className="StrapDrop">
        <div>
          <Droppable
            droppableId="strap"
            direction="vertical"
            isDropDisabled={isSlider}
          >
            {(provided, snapshot) => {
              const { isDraggingOver } = snapshot;
              let strapSmall = document.querySelector(".Strap__Small");
              if (strapSmall && dices.length < 6) {
                let height = getDicesHeight(
                  isDraggingOver ? 40 : 0
                );
                const strap = document.querySelector(".Strap__Small");
                strap.style.top = height;
              }
              return (
                <div
                  id="strapDrop"
                  ref={provided.innerRef}
                  className={isDraggingOver ? "isDraggingOver" : ""}
                >
                  {dices.map((dice, index) => (
                    <Draggable
                      key={index}
                      draggableId={`${
                        dice.mainCategory ? dice.mainCategory : "anagram"
                      }-${dice.id}-${index}`}
                      index={index}
                      isDragDisabled={isSlider}
                    >
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className={this.handleClasses(snapshot, dice, index, isDraggingOver)}
                        >
                          {index === 0 && !snapshot.isDragging && (
                            <div
                              className="StrapScrap"
                              style={{
                                backgroundImage: `url(${strap.images[5].image5})`
                              }}
                            />
                          )}
                          <div className="Dice-Trash"></div>
                          <img
                            className="Dice"
                            src={
                              dice.is_anagram
                                ? strap.images[6].image6
                                : dice.images[0]
                            }
                            alt="dice"
                            ref={e => (this.images = e)}
                            style={this.handlerStyle(dice)}
                          />
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              );
            }}
          </Droppable>
        </div>
      </div>
    );
  }
}
StrapDrop.contextType = Context;
export default memo(StrapDrop);
